import {
  // unstable_HistoryRouter as HistoryRouter,
  Routes,
  Route,
  // Router,
  useNavigate,
} from "react-router-dom";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "./appRedux/actions/CoreServicesAction";
import { useEffect, useState } from "react";
import { HomeOutlined } from "@ant-design/icons";
import React from "react";
import { Breadcrumb, Button, Layout, Menu } from "antd";

import MainPage from "./routes/MainPage";
import Profile from "./routes/profile";
import DentistLabeling from "./routes/profile/DentistLabeling";
import NotFound from "./routes/NotFound";
import Logout from "./routes/NotFound/logout";
import ProfessorProfile from "./routes/profile/ProfessorProfile";
import ExamStudent from "./routes/profile/examStudent";
import LateralCephalo from "./routes/profile/LaterallCephalo";
import OpgAnalyse from "./routes/profile/OpgAnalyse";
import PublicLateralAnalyses from "./routes/PublicLateralCelph";
import PublicCbct from "./routes/PublicCbct";
import VideoDemo from "./routes/profile/VideoDemo";
import ExamReportForStudent from "./routes/profile/examReportForStudent";
import TestDicom from "./routes/Dicom";
import NumberTeeth from "./routes/profile/NumberTeeth";
import OpgNumbering from "./routes/profile/OpgNumbering";
import Implant from "./routes/profile/implant";

import RouterProfileAnalysis from "./routes/profile/ProfileAnalysis";

import AppClinic from "./routes/profile/App/index.js";
import Test from "./routes/test/test.js";
import Segmentcaries from "./routes/profile/segmentcaries/index.js";
import PeriApicalLesion from "./routes/profile/PeriApicalLesion/index.js";
import CbctAi from "./routes/profile/cbctai/index.js";

const { Header, Content, Footer } = Layout;

const App = (props) => {
  let navigation = useNavigate();
  const [route, setRoute] = useState("");
  const NavMenu = [
    {
      label: "خانه",
      key: "home",
      icon: <HomeOutlined />,
    },
    {
      label: props.token == null ? "ورود" : "پنل کاربری",
      key: "profile",
    },
  ];
  if (props.token != null)
    NavMenu.push({ label: "خروج از حساب کاربری", key: "logout" });
  useEffect(() => {
    let token = localStorage.getItem("@token");
    if (token == null) return;
    props.actions.OfflineCoreServices("token", "jwt", token);
    console.log("tokenssssss=", token);
  }, []);

  const _onClickHeaderMenu = (e) => {
    console.log(e);
    navigation(e.key);
    setRoute(e.key);
  };
  return (
    <div>
      <Layout style={{ minHeight: "100vh", width: "100%" }}>
        <Header
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            // width: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Menu
            style={{ flex: 1 }}
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={["2"]}
            items={NavMenu}
            onClick={_onClickHeaderMenu}
          />
        </Header>
        <Content
          className="site-layout"
          style={{
            padding: "0 0px",
          }}
        >
          <div
            style={{
              // padding: 24,
              // minHeight: 380,
              background: "white",
            }}
          >
            <Routes>
              <Route index element={<MainPage />} />
              <Route path="/testdicom" element={<TestDicom />} />
              <Route path="/home" element={<MainPage />} />
              <Route path="/test" element={<Test />} />
              <Route path="/profile" element={<Profile />} />
              <Route
                path="/publiclateralchephalo/:imgpath"
                element={<PublicLateralAnalyses />}
              />
              <Route path="/cbctanalysis" element={<PublicCbct />} />
              {props.coreData["token"]?.["jwt"].data != null && (
                <>
                  <Route path="/Demo/:backtolabel" element={<VideoDemo />} />
                  <Route path="/Demo" element={<VideoDemo />} />
                  <Route
                    path="/dentistLabeling"
                    element={<DentistLabeling />}
                  />
                  <Route
                    path="/examreport"
                    element={<ExamReportForStudent />}
                  />
                  <Route path="/examStudent" element={<ExamStudent />} />
                  <Route
                    path="/professorprofile/*"
                    element={<ProfessorProfile />}
                  />
                  <Route
                    path="/lateralchephalo/*"
                    element={<LateralCephalo />}
                  />
                  <Route
                    path="/ProfileAnalysis/*"
                    element={<RouterProfileAnalysis />}
                  />
                  <Route path="/numberteeth/*" element={<NumberTeeth />} />
                  <Route path="/opgnumbering/*" element={<OpgNumbering />} />
                  <Route
                    path="/periapicallesion/*"
                    element={<PeriApicalLesion />}
                  />
                  <Route path="/cbctai/*" element={<CbctAi />} />

                  <Route path="/segmentcaries/*" element={<Segmentcaries />} />
                  <Route path="/opganalyse/*" element={<OpgAnalyse />} />
                  <Route path="/implant" element={<Implant />} />
                  <Route path="/app/*" element={<AppClinic />} />
                </>
              )}

              <Route path="/logout" element={<Logout />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Content>
        <Footer
          style={{
            textAlign: "center",
            fontFamily: "shavnaz",
          }}
        >
          Dr Zahra Ghorbani,Dr Mitra ghazi zade ,Front ReactJs,BackEnd
          C#,Database SQLserver,machine learning python
        </Footer>
      </Layout>
    </div>
  );
};
const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices },
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
  token: state.coreservices.coreData?.token?.jwt?.data,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
